// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gm-style .gm-style-iw-d::-webkit-scrollbar-track,
.gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece,
.gm-style .gm-style-iw-c,
.gm-style .gm-style-iw-t::after {
  background: rgb(137, 220, 235);
  z-index: 1;
}

/* background: rgba(233, 223, 223, 0.5); */

.gm-style .gm-style-iw-tc::after {
  background-color: rgb(126, 244, 255);
  /* background: rgba(233, 223, 223, 0.5); */
}

.gm-style .gm-style-iw-c {
  border: 1px solid black !important;
  color: rgb(0, 0, 0);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
}

/* .gm-style .gm-style-iw-t::after {
  box-shadow: none;
  border-left: 1px solid black !important;
  border-bottom: 1px solid black !important;
} */
button.gm-ui-hover-effect > span {
  background-color: #0e0d0d;
}
/* navbar.css */
.navbar {
  position: relative; /* Ensure the element is positioned */
  z-index: 7; /* Higher z-index to be on top */
}


/* leftbar.css */
.leftbar {
  position: relative; /* Ensure the element is positioned */
  z-index: 10; /* Lower z-index to be below the navbar */

}

.sidebar {
  position: relative; /* Ensure the element is positioned */
  z-index: 1; /* Lower z-index to be below the navbar */
}
`, "",{"version":3,"sources":["webpack://./src/components/Map.css"],"names":[],"mappings":"AAAA;;;;EAIE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,0CAA0C;;AAE1C;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;;;GAIG;AACH;EACE,yBAAyB;AAC3B;AACA,eAAe;AACf;EACE,kBAAkB,EAAE,qCAAqC;EACzD,UAAU,EAAE,gCAAgC;AAC9C;;;AAGA,gBAAgB;AAChB;EACE,kBAAkB,EAAE,qCAAqC;EACzD,WAAW,EAAE,yCAAyC;;AAExD;;AAEA;EACE,kBAAkB,EAAE,qCAAqC;EACzD,UAAU,EAAE,yCAAyC;AACvD","sourcesContent":[".gm-style .gm-style-iw-d::-webkit-scrollbar-track,\n.gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece,\n.gm-style .gm-style-iw-c,\n.gm-style .gm-style-iw-t::after {\n  background: rgb(137, 220, 235);\n  z-index: 1;\n}\n\n/* background: rgba(233, 223, 223, 0.5); */\n\n.gm-style .gm-style-iw-tc::after {\n  background-color: rgb(126, 244, 255);\n  /* background: rgba(233, 223, 223, 0.5); */\n}\n\n.gm-style .gm-style-iw-c {\n  border: 1px solid black !important;\n  color: rgb(0, 0, 0);\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);\n}\n\n/* .gm-style .gm-style-iw-t::after {\n  box-shadow: none;\n  border-left: 1px solid black !important;\n  border-bottom: 1px solid black !important;\n} */\nbutton.gm-ui-hover-effect > span {\n  background-color: #0e0d0d;\n}\n/* navbar.css */\n.navbar {\n  position: relative; /* Ensure the element is positioned */\n  z-index: 7; /* Higher z-index to be on top */\n}\n\n\n/* leftbar.css */\n.leftbar {\n  position: relative; /* Ensure the element is positioned */\n  z-index: 10; /* Lower z-index to be below the navbar */\n\n}\n\n.sidebar {\n  position: relative; /* Ensure the element is positioned */\n  z-index: 1; /* Lower z-index to be below the navbar */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
